export class SegmentoModel {
    constructor(
        public id: string = "",
        public descricao: string = ""
    ) { }
}
